import moment from "moment";
import { currentMonthCurrentDate } from "../../common-data/Converts";

export const validateForm = (formValues, installments = {}) => {
  let errors = {};
  const isRegular = formValues.selectedPlanType?.value === "regular";
  const isPT = formValues.selectedPlanType?.value === "addon_pt";

  const isDual = formValues.selectedPaymentMode?.value === "dual";
  const isPartial = formValues.selectedPaymentMode?.value === "partial";
  const isPartialAllowed = formValues.selectedPlan?.info?.is_partial;

  const selectedAmount = Number(formValues.planPrice || 0);

  if (!formValues.selectedGym) {
    errors.selectedGym = "Gym Is Required!";
  }

  if (!formValues.planPrice) {
    errors.planPrice = "Plan Price Is Required!";
  }

  if (!formValues.selectedSubsStartDate) {
    errors.selectedSubsStartDate = "Subscription Start Date Is Required!";
  }

  if (!formValues.selectedPlanType) {
    errors.selectedPlanType = "Plan Type Is Required!";
  }

  if (!formValues.selSourceName) {
    errors.selSourceName = "Source Name Is Required!";
  }

  if (isRegular && !formValues.selectedPlan) {
    errors.selectedPlan = "Plan Is Required!";
  }

  if (isPT) {
    if (!formValues.selectedSession) {
      errors.selectedSession = "PT Session Is Required!";
    }

    if (!formValues.selectedTrainer) {
      errors.selectedTrainer = "Trainer Is Required!";
    }

    if (!formValues.selectedSlotDate) {
      errors.selectedSlotDate = "Slot Date Is Required!";
    }

    if (formValues.selectedSlotIndex !== 0 && !formValues.selectedSlotIndex) {
      errors.selectedSlot = "Trainer Slot Is Required!";
    }
  }

  // ---------------------- NEW PAYMENT MODE ----------------------
  if (!formValues.selectedPaymentMode) {
    errors.selectedPaymentMode = "Payment Mode Is Required!";
  } else if (isRegular && isPartial && !isPartialAllowed) {
    errors.selectedPaymentMode =
      "Partial Payment Is Not Allowed For This Plan!";
  }

  if (isDual) {
    const sumOfDualAmounts =
      Number(formValues.cashAmount || 0) + Number(formValues.onlineAmount || 0);

    if (!formValues.cashAmount) {
      errors.cashAmount = "Cash Amount Is Required!";
    } else if (Number(formValues.cashAmount) <= 0) {
      errors.cashAmount = "Cash Amount Should Be Greater Than 0!";
    }

    if (!formValues.onlineAmount) {
      errors.onlineAmount = "Online Amount Is Required!";
    } else if (Number(formValues.onlineAmount) <= 0) {
      errors.onlineAmount = "Online Amount Should Be Greater Than 0!";
    }

    if (sumOfDualAmounts !== selectedAmount) {
      errors.cashAmount = "Cash Amount + Online Amount = Entered Amount!";
      errors.onlineAmount = "Cash Amount + Online Amount = Entered Amount!";
    }
  }

  if (isPartial || (isRegular && isPartial && isPartialAllowed)) {
    const firInsAmount = Number(
      installments.firInsAmount ?? formValues.firInsAmount ?? 0
    );
    const secInsAmount = Number(
      installments.secInsAmount ?? formValues.secInsAmount ?? 0
    );
    const thiInsAmount = Number(
      installments.thiInsAmount ?? formValues.thiInsAmount ?? 0
    );
    const firInsDate = installments.firInsDate ?? formValues.firInsDate;
    const secInsDate = installments.secInsDate ?? formValues.secInsDate;
    const thiInsDate = installments.thiInsDate ?? formValues.thiInsDate;

    const sumOfAllInstallments = firInsAmount + secInsAmount + thiInsAmount;

    const isFirstInstallMentDateValid =
      isPartial && firInsDate
        ? moment(firInsDate, "YYYY-MM-DD").isBefore(
            moment(currentMonthCurrentDate, "YYYY-MM-DD")
          )
        : "";

    const isSecondInstallMentDateValid =
      isPartial && secInsDate
        ? moment(secInsDate, "YYYY-MM-DD").isBefore(
            moment(firInsDate, "YYYY-MM-DD")
          )
        : "";

    const isThirdInstallMentDateValid =
      isPartial && thiInsDate && thiInsAmount !== 0
        ? moment(thiInsDate, "YYYY-MM-DD").isBefore(
            moment(secInsDate, "YYYY-MM-DD")
          )
        : "";

    if (!formValues.selectedFirstPartialPaymentMode) {
      errors.selectedFirstPartialPaymentMode =
        "First Installment Payment Mode Is Required!";
    }

    if (!firInsAmount) {
      errors.firInsAmount = "First Installment Amount Is Required!";
    } else if (firInsAmount < 0) {
      errors.firInsAmount =
        "First Installment Amount Should Be Greater Than Or Equal 0!";
    }

    if (!secInsAmount) {
      errors.secInsAmount = "Second Installment Amount Is Required!";
    } else if (secInsAmount < 0) {
      errors.secInsAmount =
        "Second Installment Amount Should Be Greater Than Or Equal 0!";
    }

    if (thiInsAmount !== 0 && !thiInsAmount) {
      errors.thiInsAmount = "Third Installment Amount Is Required!";
    } else if (thiInsAmount < 0) {
      errors.thiInsAmount =
        "Third Installment Amount Should Be Greater Than Or Equal 0!";
    }

    if (sumOfAllInstallments !== selectedAmount) {
      errors.firInsAmount =
        "First Installment, Second Installment & Third Installment Should Be Equal To Selected Amount!";
      errors.secInsAmount =
        "First Installment, Second Installment & Third Installment Should Be Equal To Selected Amount!";
      errors.thiInsAmount =
        "First Installment, Second Installment & Third Installment Should Be Equal To Selected Amount!";
    }

    if (!firInsDate) {
      errors.firInsDate = "First Installment Due Date Is Required!";
    } else if (isFirstInstallMentDateValid) {
      errors.firInsDate =
        "First Installment Due Date Should Be Greater Than Current Date!";
    }

    if (!secInsDate) {
      errors.secInsDate = "Second Installment Due Date Is Required!";
    } else if (isSecondInstallMentDateValid) {
      errors.secInsDate =
        "Second Installment Due Date Should Be Greater Than First Installment Date!";
    }

    if (!thiInsDate) {
      errors.thiInsDate = "Third Installment Due Date Is Required!";
    } else if (isThirdInstallMentDateValid) {
      errors.thiInsDate =
        "Third Installment Due Date Should Be Greater Than Second Installment Date!";
    }
  }

  return errors;
};
